import {
  Button,
  ButtonRole,
  ButtonSize,
  ButtonTargetKind,
} from "@components/Button";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

import { useNpsContext } from "src/context/NpsContext";
import {
  nextNpsStep,
  setNpsScore,
  submitNpsScore,
} from "src/context/NpsContext/actions";
import { colorCssVars } from "src/theme/color";
import { cssForMediaSize, MediaSize } from "src/theme/mediaQueries";
import { verticalStackCss } from "src/theme/spacing";
import { FontWeight } from "src/theme/text";

const scoreOptions = new Array(11).fill(0).map((_, index) => index);

const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;

  width: 24px;
  height: 40px;

  font-weight: ${FontWeight.MEDIUM};
  color: var(${colorCssVars.accent.large});
  background: #f3f6f6;
  border-radius: 4px;

  &:hover {
    background: #ffffff;
    color: var(${colorCssVars.accent.small});
    box-shadow: 0px 5px 25px -5px rgba(46, 52, 52, 0.2);
  }

  &:active {
    background: var(${colorCssVars.accent.large});
    color: #ffffff;
  }

  ${cssForMediaSize({
    min: MediaSize.MEDIUM,
    css: css`
      width: 32px;
      height: 40px;
    `,
  })}
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 2px;
`;

export const NpsScore: React.FCC = () => {
  const { userKind, nonprofitId } = useNpsContext();
  const onSubmit = (score: number) => {
    if (userKind) {
      submitNpsScore({ score, userKind, nonprofitId });
    }
    nextNpsStep();
    setNpsScore(score);
  };

  return (
    <div css={verticalStackCss.s}>
      <p>How likely are you to recommend Every.org to a friend or colleague?</p>
      <ButtonsContainer>
        {scoreOptions.map((score) => (
          <StyledButton
            data-tname={`nps_score_${score}`}
            key={score}
            role={ButtonRole.UNSTYLED}
            size={ButtonSize.MEDIUM}
            onClick={{
              kind: ButtonTargetKind.FUNCTION,
              action: () => {
                onSubmit(score);
              },
            }}
          >
            {score.toString()}
          </StyledButton>
        ))}
      </ButtonsContainer>
    </div>
  );
};
